import React, { useContext } from 'react';

import { FilterContext } from '../../../../../Context/FilterContext';
import { AccountOnlineAnalysis } from '../../../../../MyLom/Account/EditAccount/Types';
import { formatDate } from '../../../../../Utils';
import { CustomerSpecificData, FilterType } from '../../../../Types';
import Icon from './Icon';
import { balloonPositionMap } from './BalloonPosition';

import './Badges.scss';

interface Props {
    customerSpecificData: CustomerSpecificData | null;
    alignment: 'left' | 'center' | 'right';
}

const SkinAnalysisBadge: React.FunctionComponent<Props> = (props) => {
    const { onlineAnalysis } = useContext(FilterContext);

    if (props.customerSpecificData === null) {
        return null;
    }

    const balloonText = getBalloonText(props.customerSpecificData, onlineAnalysis);
    if (balloonText === null) {
        return null;
    }

    const passesSkinCheck = props.customerSpecificData.passesSkinCheck;
    return (
        <div
            className={
                'product-check' +
                ' ' +
                (passesSkinCheck ? 'product-check--ok' : 'product-check--warning') +
                ' ' +
                'product-check--' +
                props.alignment
            }
            aria-label={balloonText}
            data-balloon-pos={balloonPositionMap.get(props.alignment)}
            data-balloon-length="large"
        >
            <span>Hautbild</span>
            <Icon passesCheck={passesSkinCheck} />
        </div>
    );
};

const getBalloonText = (
    customerSpecificData: CustomerSpecificData,
    onlineAnalysis: AccountOnlineAnalysis | null,
): string | null => {
    const passesSkinCheck = customerSpecificData.passesSkinCheck;

    if (customerSpecificData.filterType === FilterType.standardFilter) {
        if (passesSkinCheck) {
            return `Das Produkt ist gemäß Standardfilter geeignet`;
        } else {
            return `Das Produkt wird gemäß Standardfilter nicht empfohlen`;
        }
    }

    if (customerSpecificData.filterType === FilterType.onlineAnalysis) {
        if (onlineAnalysis) {
            const date = onlineAnalysis.creationDateTime ? formatDate(new Date(onlineAnalysis.creationDateTime)) : null;

            if (passesSkinCheck) {
                return `Das Produkt ist gemäß Online-Hautbild-Analyse vom ${date} geeignet`;
            } else {
                return `Das Produkt wird gemäß Online-Hautbild-Analyse vom ${date} nicht empfohlen`;
            }
        }
    }

    if (customerSpecificData.filterType === FilterType.skinAnalysis) {
        const date = customerSpecificData.skinAnalysisDate
            ? formatDate(new Date(customerSpecificData.skinAnalysisDate))
            : null;

        if (passesSkinCheck) {
            return `Das Produkt ist gemäß Fachberater Hautbild-Analyse vom ${date} geeignet`;
        } else {
            return `Das Produkt wird gemäß Fachberater Hautbild-Analyse vom ${date} nicht empfohlen`;
        }
    }

    return null;
};

export default SkinAnalysisBadge;
